import { Group, Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { OpenQuestion } from "anketa-core/open_question";
import { TextValidator } from "anketa-core/validation";

export const setupIntuneGroup = (intuneScanners: Section, idx = 0) => {
  const intuneGroup = intuneScanner(idx);
  intuneScanners.addChild(intuneGroup.intuneScanner);

  function onConfigChange() {
    const name = intuneGroup.intuneName.fact.raw;

    if (name && name.toString().trim() !== "") {
      intuneGroup.intuneName.removeChangeListener(onConfigChange);
      setupIntuneGroup(intuneScanners, idx + 1);
    }
  }

  intuneGroup.intuneName.addChangeListener(onConfigChange);
};

export const intuneScanner = (
  idx: number
): { intuneScanner: Group; intuneName: OpenQuestion } => {
  const idPrefix = `intune_scanner_${idx}`;

  const intuneScanner = new Group(idPrefix, [
    new Translation("en", "Unconfigured Intune Scanner"),
    new Translation("de", "Unkonfigurierter Intune Scanner"),
  ]);

  const name = new OpenQuestion(`${idPrefix}_name`, [
    new Translation("en", "Display name"),
    new Translation("de", "Anzeigename"),
  ]);
  name.validator = new TextValidator();

  name.required = true;
  name.addChangeListener(() => {
    const plainName = name.fact.raw.toString();
    if (plainName.trim() !== "") {
      intuneScanner.title = [
        new Translation("en", plainName),
        new Translation("de", plainName),
      ];
    } else {
      intuneScanner.title = [
        new Translation("en", "Unconfigured Intune Scanner"),
        new Translation("de", "Unkonfigurierter Intune Scanner"),
      ];
    }
  });
  intuneScanner.addChild(name);

  const intuneTenantId = new OpenQuestion(`${idPrefix}_tenant_id`, [
    new Translation("en", "Azure Tenant ID"),
    new Translation("de", "Azure-Mandanten-ID"),
  ]);
  intuneTenantId.validator = new TextValidator();

  intuneTenantId.required = true;
  intuneTenantId.help = [
    new Translation(
      "en",
      "The Azure Active Directory Tenant ID associated with your Microsoft Intune environment."
    ),
    new Translation(
      "de",
      "Die Azure Active Directory Mandanten-ID, die Ihrer Microsoft Intune-Umgebung zugeordnet ist."
    ),
  ];
  intuneScanner.addChild(intuneTenantId);

  const intuneClientId = new OpenQuestion(`${idPrefix}_client_id`, [
    new Translation("en", "Azure Client ID"),
    new Translation("de", "Azure-Client-ID"),
  ]);
  intuneClientId.validator = new TextValidator();
  intuneClientId.required = true;
  intuneClientId.help = [
    new Translation(
      "en",
      "The Client ID of the Azure AD application registered for API access."
    ),
    new Translation(
      "de",
      "Die Client-ID der für den API-Zugriff registrierten Azure AD-Anwendung."
    ),
  ];
  intuneScanner.addChild(intuneClientId);

  const intuneClientSecret = new OpenQuestion(`${idPrefix}_client_secret`, [
    new Translation("en", "Azure Client Secret"),
    new Translation("de", "Azure-Client-Secret"),
  ]);
  intuneClientSecret.required = true;
  intuneClientSecret.readonly = true;

  intuneClientSecret.help = [
    new Translation(
      "en",
      "The Client Secret generated for the Azure AD application."
    ),
    new Translation(
      "de",
      "Das für die Azure AD-Anwendung generierte Client-Secret."
    ),
  ];
  intuneScanner.addChild(intuneClientSecret);

  return { intuneScanner: intuneScanner, intuneName: name };
};
